import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, appLoginPath } from '../api/client';

export function useAuth() {
  const qc = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['auth'],
    queryFn: () => api.get('/auth/me').then(r => r.data),
    retry: false,
  });

  const loginMutation = useMutation({
    mutationFn: (password: string) => api.post('/auth/login', { password }).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['auth'] }),
  });

  const logoutMutation = useMutation({
    mutationFn: () => api.post('/auth/logout').then(r => r.data),
    onSuccess: () => {
      qc.clear();
      window.location.href = appLoginPath;
    },
  });

  return {
    isAuthenticated: data?.authenticated === true,
    isLoading,
    login: loginMutation.mutateAsync,
    loginPending: loginMutation.isPending,
    loginError: loginMutation.isError,
    logout: logoutMutation.mutate,
  };
}
